var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.705 8.70711C25.0956 8.31658 25.0956 7.68342 24.705 7.29289C24.3145 6.90237 23.6814 6.90237 23.2908 7.29289L15.9987 14.585L8.70711 7.29337C8.31658 6.90284 7.68342 6.90284 7.29289 7.29337C6.90237 7.68389 6.90237 8.31705 7.29289 8.70758L14.5848 15.9994L7.29289 23.2913C6.90237 23.6818 6.90237 24.315 7.29289 24.7055C7.68342 25.096 8.31658 25.096 8.70711 24.7055L15.9992 17.4134L23.2908 24.705C23.6814 25.0956 24.3145 25.0956 24.705 24.705C25.0956 24.3145 25.0956 23.6814 24.705 23.2908L17.4132 15.999L24.705 8.70711Z",
    fill: "#202117"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f1a6cf89a9a98ee5dcad81cd1c69312a.svg";
export { ForwardRef as ReactComponent };